import React from "react";

export type OpTab = "configurations" | "build-specs";

const TABS: { id: OpTab; label: string }[] = [
  { id: "configurations", label: "Configurations" },
  { id: "build-specs", label: "Build Specs" },
];

interface OpTabNavProps {
  activeTab: OpTab;
  onChange: (tab: OpTab) => void;
}

const OpTabNav = ({ activeTab, onChange }: OpTabNavProps) => (
  <nav className="tab-nav" role="tablist" aria-label="On-Pipe configurator sections">
    <div className="tab-nav__inner">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`tab-button${activeTab === tab.id ? " tab-button--active" : ""}`}
          role="tab"
          aria-selected={activeTab === tab.id}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  </nav>
);

export default OpTabNav;
